import template from './HsaVerification.html';

import { ComponentBase } from "../Common/componentBase";
import { RegisterDefaultComponent } from "../Common/componentsHelpers";


export class HsaVerificationViewModel extends ComponentBase {
    constructor(params) {
        super(params);

        this.cipPortalPath = $.cdh.global.cipPortalPath;
    }


}

RegisterDefaultComponent('hsa-verification', template, HsaVerificationViewModel);

window.addEventListener('message', function(event) {
    if (event.data && event.data.type === 'setIframeHeight') {
        var iframe = document.getElementById('hsa-verification-frame');
        if (iframe) {
            iframe.style.height = event.data.height  + 'px';
        }
    }
});